import "./style.scss";

import React, { useState } from "react";

import ButtonPrimary from "../../components/buttonPrimary";
import { useDispatch } from "react-redux";
import {
  resetAll,
  resetState,
  setStartTime,
  setTimer,
} from "../../store/ingredient";
import moment from "moment";

import logoImage from "../../assets/images/logo.svg";
import burgerImage from "../../assets/images/onboarding/burger.svg";
import buttonSound from "../../assets/sound/button.mp3";
import OnboardingPopup from "../../components/onboardingPopups";
import TutorialVideo from "../../assets/videos/tutorialVideo.mp4";
import { storage } from "../../services/config/storage";

const Tutorial = (props) => {
  const dispatch = useDispatch();

  const [step, setstep] = useState(0);

  const [vidEnded, setVidEnded] = useState(false);
  const gameDetails = storage.get.gameDetails();

  const buttonClickHandler = () => {
    props.history.push("/main");
    // props.history.push("/onboarding");
    var now = moment(); // new Date().getTime();
    dispatch(setTimer(Date.now() + 300000));
    dispatch(setStartTime(moment()));
    dispatch(resetState());
    dispatch(resetAll({ isDemo: false }));

    const buttonSound = document.getElementById("buttonSound");
    buttonSound.play();
  };

  return (
    <div className="tutorial-root bg-primary">
      <div className="logo">
      {
        gameDetails?.mediaUrl ?
        <img src={gameDetails.mediaUrl} alt="" />:
        <img src={logoImage} alt="" />
      }
      </div>

      {step == 0 && (
        <div className="full-overlay-click">
          <OnboardingPopup
            title={"Time to make some Burgers!"}
            description={
              "You’re the chef of a busy cafe and you’ll be serving burger orders before the time runs out."
            }
            className="first-popup"
            descriptionColor={"#737379"}
            topLeftOutImage={burgerImage}
          >
            <ButtonPrimary
              buttonText="Watch Video Tutorial"
              onClickHandler={() => setstep(step + 1)}
            />
          </OnboardingPopup>

          {/* <div className="start-buttons">

                    <div className="button">
                        <ButtonPrimary
                            buttonText="Start Game"
                            onClickHandler={() => buttonClickHandler()}
                        />
                    </div>

                    <div className="replay-tutorial">
                        <button className="btn" onClick={() => setstep(0)}>
                            Replay Tutorial
                        </button>
                    </div>
                </div> */}
        </div>
      )}

      {step == 1 && (
        <>
          <div className="title-element">See it in action!</div>

          <div className="video-container">
              <video width={400} controls>
                <source src={TutorialVideo}  type="video/mp4"></source>
              </video>
          </div>

          <div className="buttons">
            {vidEnded && (
              <ButtonPrimary
                buttonText="Start Game"
                onClickHandler={() => buttonClickHandler()}
              />
            )}

            {!vidEnded && (
              <button className="btn skip" onClick={() => setstep(step + 1)}>
                Skip Tutorial &gt;
              </button>
            )}
          </div>
        </>
      )}

      {step >= 2 && (
        <div className="start-game-prompt">
          <OnboardingPopup
            title={"You're all set!"}
            description={
              "Make sure you serve them right and fast to keep your customers happy"
            }
            className="first-popup"
            descriptionColor={"#737379"}
            // topLeftOutImage={burgerImage}
          >
            <ButtonPrimary
              buttonText="Start Game"
              onClickHandler={() => buttonClickHandler()}
            />
          </OnboardingPopup>
        </div>
      )}

      <audio controls id="buttonSound" className="audio-hide">
        <source src={buttonSound} type="audio/mp3" />
      </audio>
    </div>
  );
};

export default Tutorial;
